exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".form-row{position:relative;margin-bottom:1.375rem}.form-row.button-wrapper{text-align:center}.form-row.instructions{font-size:.75rem}.form-row:last-child{margin-bottom:0}@media screen and (max-width:29.4375em){.modal-form .form-row{padding-left:.75rem;padding-right:.75rem}}@media screen and (min-width:36.5em){.form-row.has-columns{display:flex;justify-content:space-between;width:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/FormRow/FormRow.scss
// module id = 678
// module chunks = 0